<div class="viewport-1" id="task-select" tabindex="0" (keyup)="autoCompleteSubtask($event)" [style.background-image]="'url(' + taskSelectBackgroundImage + ')'">
  <student-header #studentHeader></student-header>
  <side-menu #sideMenu (selectedAvatar)="updateSelectedAvatar($event)" [disabled]="disableSideButton"></side-menu>

  <div [ngStyle]="{'background-image': 'url(' + taskSelectBackgroundImage + ')'}">
    <div class="subtask-select-container"
         [ngStyle]="{ 'background-image': 'url(' + subtaskSelectBackgroundImage + ')' }"
         [ngClass]="{
           'complete': allSubtasksComplete,
           'theme2': studentDataService.getStudentThemeNumber() === THEMES.secondary,
           'theme1' : studentDataService.getStudentThemeNumber() === THEMES.elementary
         }"
    >
      <div class="back-button">
        <button class="task_bar_button" [ngClass]="{'back_button_animate': isPulse}" (click)="goBack()"></button>
      </div>
      <div class="subtask-progress font-20">
        <div>{{ completedTasks }} / {{ totalTasks }}</div>
      </div>
      <div class="tasks">
        <ng-container *ngFor="let subtaskButton of subtaskButtonList;  let idx = index">
          <wf-subtask-select-button
            [taskSelect]="subtaskButton"
            (onTaskSelectClick)="gotoSubtask($event)"
            (onTaskMouseLeave)="toggleHighlight($event.idx, $event.highlight)"
            (onTaskMouseOver)="toggleHighlight($event.idx, $event.highlight)"
          />
        </ng-container>
      </div>
    </div>
  </div>
  <student-footer #studentFooter timerBackgroundImage="/assets/images/timer/timerLabel-task.svg"></student-footer>
</div>
